import { render, staticRenderFns } from "./workbenchBank.vue?vue&type=template&id=bf8dda6c&scoped=true"
import script from "./workbenchBank.vue?vue&type=script&lang=js"
export * from "./workbenchBank.vue?vue&type=script&lang=js"
import style0 from "./workbenchBank.vue?vue&type=style&index=0&id=bf8dda6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf8dda6c",
  null
  
)

export default component.exports